export type AuthRole = {
    _id?: string;
    id?: string;
    name?: string;
    permissions?: string[];
};

export type PermissionUser = {
    role?: string | AuthRole;
};

export const getRoleName = (role: PermissionUser["role"]): string => {
    if (typeof role === "string") return role;
    return role?.name ?? "";
};

export const isSuperAdmin = (user: PermissionUser | null | undefined): boolean => {
    const normalizedRoleName = getRoleName(user?.role).toLowerCase().replace(/[\s_-]/g, "");
    return normalizedRoleName === "superadmin";
};

export const hasPermission = (user: PermissionUser | null | undefined, permission: string): boolean => {
    const role = user?.role;
    const roleName = getRoleName(role).toLowerCase();

    if (roleName === "admin" || isSuperAdmin(user)) return true;
    if (!role || typeof role === "string") return false;

    return Array.isArray(role.permissions) && role.permissions.includes(permission);
};
